import React from 'react';
import styled, { css } from 'styled-components';

const Overlay = styled.div`
  display: none;
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(7, 16, 29, 0.38);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  ${props =>
    props.visible &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`;

const WelcomeCard = styled.div`
  width: min(92vw, 460px);
  padding: 2rem 2rem 1.75rem;
  border-radius: 1.25rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(245, 249, 255, 0.94) 100%);
  box-shadow: 0 28px 60px rgba(18, 48, 87, 0.22);
  border: 1px solid rgba(47, 115, 200, 0.12);
  text-align: center;
`;

const Accent = styled.div`
  width: 64px;
  height: 64px;
  margin: 0 auto 1.1rem;
  border-radius: 1rem;
  background: linear-gradient(135deg, #1d4f8f 0%, #2f73c8 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 14px 28px rgba(47, 115, 200, 0.24);

  i {
    color: #fff;
    font-size: 1.4rem;
  }
`;

const Title = styled.h1`
  margin: 0 0 0.5rem;
  color: #17314d;
  font-size: 2rem;
  font-weight: 800;
`;

const Name = styled.p`
  margin: 0 0 0.45rem;
  color: #1d4f8f;
  font-size: 1.18rem;
  font-weight: 700;
`;

const Copy = styled.p`
  margin: 0;
  color: #66788b;
  font-size: 0.98rem;
  line-height: 1.6;
`;

export default function BienvenidoComponent({ Visible, nombre }) {
  return (
    <Overlay visible={Visible}>
      <WelcomeCard>
        <Accent>
          <i className="ni ni-check-bold" />
        </Accent>
        <Title>Bienvenido</Title>
        {nombre ? <Name>{nombre}</Name> : null}
        <Copy>Accediendo al panel operativo de GlobalNet.</Copy>
      </WelcomeCard>
    </Overlay>
  );
}
